import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../../../core/services/translation.service';

@Component({
  selector: 'app-setting',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './setting.html',
  styleUrl: './setting.css',
})
export class Setting {
  private translationService = inject(TranslationService);

  currentLang = this.translationService.adminLang;

  setLanguage(lang: 'en' | 'mm') {
    this.translationService.setAdminLanguage(lang);
  }
}
